// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_EXP_HOMEPAGE_TITLE = "Va\u0161e sk\u00fasenosti";
